// extracted by mini-css-extract-plugin
export default {"addressAction":"p6-z","loading":"q6-z"};